<style scoped>
    .go-top-image-wrap {
        position: fixed;
        top: 90%;
        right: 0;
        cursor: pointer;
    }
</style>

<template>
    <div class="go-top-image-wrap">
        <img :src="isGoTopImage ? goTopImage[1] : goTopImage[0]" alt="" 
        @mouseenter="goTopImageChange" @mouseleave="goTopImageChange" @click="goImageClicked">
    </div>
</template>

<script>
    export default {
        name: 'go_top_image',
        data() {
            return {
                goTopImage: [
                    require('../../../assets/image/common/common_go_top@2x.png'),
                    require('../../../assets/image/common/common_light_go_top@2x.png')
                ],
                isGoTopImage: false
            }
        },
        methods: {
            goTopImageChange() {
                this.isGoTopImage = !this.isGoTopImage
            },
            goImageClicked() {
                this.$emit('change')
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/page/common/GoTopImage.vue